export default [
    {
        path: '/terms-of-service',
        name: 'terms-of-service',
        props: { module: 'auth' },
        component: () => import('@/views/cms/CmsPages.vue'),
        meta: {
            resource: 'Auth',
            pageTitle: 'Terms of Service',
            layout: 'full',
            redirectIfLoggedIn: true,
            module: 'terms',
        },
    },
    {
        path: '/privacy-policy',
        name: 'privacy-policy',
        props: { module: 'auth' },
        component: () => import('@/views/cms/CmsPages.vue'),
        meta: {
            resource: 'Auth',
            pageTitle: 'Privacy Policy',
            layout: 'full',
            redirectIfLoggedIn: true,
            module: 'privacy_policy',
        },
    },
]
